import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import gql from "graphql-tag";
import { cloneDeep, get as _get } from "lodash";
import { environment } from "@environments/environment";
import { AuthService } from "@examsoft/es-login";
import { AppSyncService } from "../app-sync/app-sync.service";
import * as subscriptions from "./graphql/subscription";
import * as queries from "./graphql/query";
import * as mutations from "./graphql/mutation";
var PollDataService = /** @class */ (function () {
    function PollDataService(authService, appsync, http) {
        this.authService = authService;
        this.appsync = appsync;
        this.http = http;
        this.pollHistory = new BehaviorSubject(null);
        this.gatewayApiUrl = environment.urls.gatewayApiUrl;
        this.client = this.appsync.client;
    }
    PollDataService.prototype.getPolls = function (esId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.hydrated()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.client
                                .query({
                                query: gql(queries.getPolls),
                                variables: {
                                    esId: esId,
                                },
                                fetchPolicy: "network-only",
                            })
                                .then(function (pollResults) {
                                return pollResults.data.getPolls.map(function (poll) {
                                    return {
                                        id: poll.sk,
                                        courseId: poll.courseId,
                                        title: poll.title,
                                        portalPid: poll.portalPid,
                                        numQuestions: poll.numQuestions,
                                        numStudents: poll.numStudents,
                                        scheduleDate: poll.scheduleDate,
                                        status: poll.LSI1SK,
                                    };
                                });
                            })];
                }
            });
        });
    };
    PollDataService.prototype.getStudentPolls = function (esId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.hydrated()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.client
                                .query({
                                query: gql(queries.getStudentPolls),
                                variables: {
                                    studentId: esId,
                                    pollStatus: "active",
                                },
                                fetchPolicy: "network-only",
                            })
                                .then(function (pollResults) {
                                return pollResults.data.getStudentPolls.map(function (poll) {
                                    return {
                                        id: poll.sk,
                                        portalPid: poll.portalPid,
                                        title: poll.title,
                                    };
                                });
                            })];
                }
            });
        });
    };
    PollDataService.prototype.getPoll = function (pollId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.hydrated()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.client
                                .query({
                                query: gql(queries.getPoll),
                                variables: {
                                    pollId: pollId,
                                },
                                fetchPolicy: "network-only",
                            })
                                .then(function (_a) {
                                var data = _a.data;
                                var poll = data.getPoll;
                                return {
                                    id: poll.pk,
                                    title: poll.title,
                                    portalPid: poll.portalPid,
                                    numQuestions: poll.numQuestions,
                                    numStudents: poll.numStudents,
                                    scheduleDate: poll.scheduleDate,
                                    status: poll.LSI1SK,
                                    lastAccessed: poll.lastAccessed,
                                    lastInstructor: poll.lastInstructor,
                                    currentQuestion: parseInt(poll.currentQuestion, 10),
                                };
                            })];
                }
            });
        });
    };
    PollDataService.prototype.getPollUpdates = function (pollId) {
        return this.client
            .subscribe({
            query: gql(subscriptions.onUpdatePoll),
            variables: { pk: pollId },
            fetchPolicy: "network-only",
        })
            .map(function (pollResults) {
            var poll = pollResults.data.onUpdatePoll;
            return {
                id: poll.pk,
                currentQuestion: parseInt(poll.currentQuestion, 10),
                status: poll.LSI1SK,
                lastAccessed: poll.lastAccessed,
            };
        });
    };
    PollDataService.prototype.getActivePollUpdates = function (studentId) {
        return this.client
            .subscribe({
            query: gql(subscriptions.onActivateUserPoll),
            variables: { pk: studentId },
            fetchPolicy: "network-only",
        })
            .map(function (results) {
            var activeUserPoll = results.data.onActivateUserPoll;
            return {
                studentId: activeUserPoll.pk,
                pollId: activeUserPoll.sk,
                pollStatus: activeUserPoll.LSI1SK,
            };
        });
    };
    PollDataService.prototype.completeUserPoll = function (esId, pollId) {
        return this.client
            .mutate({
            mutation: gql(mutations.completeUserPoll),
            variables: {
                esId: esId,
                pollId: pollId,
            },
        })
            .then(function (pollResults) {
            var data = pollResults.data.completeUserPoll;
            return {
                esId: data.pk,
                pollId: data.sk,
                status: data.LSI1SK,
            };
        });
    };
    PollDataService.prototype.updatePollInput = function (pk, sk, currentQuestion, status, lastInstructor) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.hydrated()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.client
                                .mutate({
                                mutation: gql(mutations.updatePollInput),
                                variables: {
                                    pk: pk,
                                    sk: sk,
                                    currentQuestion: this.padQuestionNumber(currentQuestion),
                                    LSI1SK: status,
                                    lastInstructor: lastInstructor,
                                },
                                optimisticResponse: function () {
                                    return {
                                        updatePollInput: {
                                            __typename: "Poll",
                                            sk: sk,
                                            pk: pk,
                                            currentQuestion: _this.padQuestionNumber(currentQuestion),
                                            LSI1SK: status,
                                            lastInstructor: lastInstructor,
                                            lastAccessed: 0,
                                        },
                                    };
                                },
                                update: function (cache, _a) {
                                    var updatePollInput = _a.data.updatePollInput;
                                    var query = gql(queries.getPoll);
                                    var data = cache.readQuery({ query: query, variables: { pk: pk } });
                                    data.getPoll = tslib_1.__assign({}, cloneDeep(data.getPoll), cloneDeep(updatePollInput));
                                    cache.writeQuery({ query: query, data: data });
                                },
                            })
                                .then(function (pollResults) {
                                return {
                                    id: pollResults.data.updatePollInput.pk,
                                    currentQuestion: parseInt(pollResults.data.updatePollInput.currentQuestion, 10),
                                    status: pollResults.data.updatePollInput.LSI1SK,
                                };
                            })];
                }
            });
        });
    };
    PollDataService.prototype.updatePollDetails = function (pollId, currentQuestion, status, esId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.hydrated()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.client
                                .mutate({
                                mutation: gql(mutations.updatePoll),
                                variables: {
                                    pollId: pollId,
                                    currentQuestion: this.padQuestionNumber(currentQuestion),
                                    status: status,
                                    esId: esId,
                                },
                                optimisticResponse: function () {
                                    return {
                                        updatePoll: {
                                            __typename: "Poll",
                                            pk: pollId,
                                            currentQuestion: _this.padQuestionNumber(currentQuestion),
                                            LSI1SK: status,
                                            lastInstructor: esId,
                                            lastAccessed: 0,
                                        },
                                    };
                                },
                                update: function (cache, _a) {
                                    var updatePoll = _a.data.updatePoll;
                                    var query = gql(queries.getPoll);
                                    var data = cache.readQuery({ query: query, variables: { pollId: pollId } });
                                    data.getPoll = tslib_1.__assign({}, cloneDeep(data.getPoll), cloneDeep(updatePoll));
                                    cache.writeQuery({ query: query, data: data });
                                },
                            })
                                .then(function (pollResults) {
                                return {
                                    id: pollResults.data.updatePoll.pk,
                                    currentQuestion: parseInt(pollResults.data.updatePoll.currentQuestion, 10),
                                    status: pollResults.data.updatePoll.LSI1SK,
                                };
                            })];
                }
            });
        });
    };
    PollDataService.prototype.updateLastAccessed = function (pk, sk) {
        return this.client
            .mutate({
            mutation: gql(mutations.updateLastAccessed),
            variables: {
                pk: pk,
                sk: sk,
            },
        })
            .then(function (pollResults) {
            return _get(pollResults, "data.updateLastAccessed", {
                pk: null,
                sk: null,
                lastAccessed: null,
            });
        });
    };
    PollDataService.prototype.activateUserPolls = function (pollId) {
        return this.http
            .post(this.gatewayApiUrl + "/examnow-appsync-mutations/" + pollId, { action: "activate", payload: { pollId: pollId } }, this.getHttpOptions())
            .toPromise();
    };
    PollDataService.prototype.completePoll = function (pollId) {
        return Promise.all([
            this.http
                .post(
            //update poll user records to complete
            this.gatewayApiUrl + "/examnow-appsync-mutations/" + pollId, { action: "complete", payload: { pollId: pollId } })
                .toPromise(),
            this.http
                .post(
            //update main poll record to complete
            this.gatewayApiUrl + "/AudienceResponseAnswerUpload/" + pollId, { pollId: pollId })
                .toPromise(),
        ]).then(function (_a) {
            var activations = _a[0], completed = _a[1];
        });
    };
    PollDataService.prototype.getPollStudents = function (pollId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.hydrated()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.client
                                .query({
                                query: gql(queries.getPollStudents),
                                variables: {
                                    pollId: pollId,
                                },
                                fetchPolicy: "network-only",
                            })
                                .then(function (students) {
                                return students.data.getPollStudents.map(function (student) {
                                    return {
                                        studentId: student.pk,
                                        pollId: student.sk,
                                    };
                                });
                            })];
                }
            });
        });
    };
    PollDataService.prototype.getPollQuestions = function (pollId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.hydrated()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.client
                                .query({
                                query: gql(queries.getPollQuestions),
                                variables: {
                                    pollId: pollId,
                                },
                                fetchPolicy: "network-only",
                            })
                                .then(function (response) {
                                var pollQuestions = response.data.getPollQuestions;
                                return pollQuestions.map(function (q) {
                                    return {
                                        id: q.sk,
                                        stem: q.stem,
                                        type: q.type,
                                        questionStatus: q.questionStatus,
                                        choices: q.choices,
                                        enableAllThatApply: q.enableAllThatApply,
                                        mcAnswer: q.mcAnswer,
                                        tfAnswer: q.tfAnswer,
                                        fitbAnswer: q.fitbAnswer,
                                    };
                                });
                            })];
                }
            });
        });
    };
    PollDataService.prototype.getPollQuestion = function (pollId, currentQuestion) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.hydrated()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.client
                                .query({
                                query: gql(queries.getPollQuestion),
                                variables: {
                                    pollId: pollId,
                                    currentQuestion: this.padQuestionNumber(currentQuestion),
                                },
                                fetchPolicy: "network-only",
                            })
                                .then(function (response) {
                                var pollQuestion = response.data.getPollQuestion;
                                return {
                                    id: pollQuestion.sk,
                                    stem: pollQuestion.stem,
                                    type: pollQuestion.type,
                                    questionStatus: pollQuestion.questionStatus,
                                    choices: pollQuestion.choices,
                                    enableAllThatApply: pollQuestion.enableAllThatApply,
                                    fitbAnswer: pollQuestion.fitbAnswer,
                                    mcAnswer: pollQuestion.mcAnswer,
                                    tfAnswer: pollQuestion.tfAnswer,
                                };
                            })];
                }
            });
        });
    };
    PollDataService.prototype.getQuestionStatusUpdates = function (pollId, questionId) {
        return this.client
            .subscribe({
            query: gql(subscriptions.onUpdateQuestionStatus),
            variables: {
                pk: pollId,
                sk: this.padQuestionNumber(questionId),
            },
            fetchPolicy: "network-only",
        })
            .map(function (questionResults) {
            var q = questionResults.data.onUpdateQuestionStatus;
            return {
                id: q.sk,
                questionStatus: q.questionStatus,
            };
        });
    };
    PollDataService.prototype.updateQuestionStatus = function (pollId, currentQuestion, questionStatus) {
        var _this = this;
        return this.client
            .mutate({
            mutation: gql(mutations.updateQuestionStatus),
            variables: {
                pollId: pollId,
                questionId: this.padQuestionNumber(currentQuestion),
                questionStatus: questionStatus,
            },
            optimisticResponse: function () {
                return {
                    updateQuestionStatus: {
                        __typename: "Question",
                        pk: pollId,
                        sk: _this.padQuestionNumber(currentQuestion),
                        questionStatus: questionStatus,
                    },
                };
            },
            update: function (cache, _a) {
                var updateQuestionStatus = _a.data.updateQuestionStatus;
                var query = gql(queries.getPollQuestions);
                var data = cache.readQuery({ query: query, variables: { pollId: pollId } });
                data.getPollQuestions.forEach(function (question) {
                    if (question.sk === _this.padQuestionNumber(currentQuestion)) {
                        question.questionStatus = questionStatus;
                    }
                });
                cache.writeQuery({ query: query, data: data });
            },
        })
            .then(function (_a) {
            var updateQuestionStatus = _a.data.updateQuestionStatus;
            return {
                id: updateQuestionStatus.sk,
                questionStatus: updateQuestionStatus.questionStatus,
            };
        });
    };
    PollDataService.prototype.getPollResponses = function (pollId, responseId) {
        if (responseId === void 0) { responseId = null; }
        return this.client
            .query({
            query: gql(queries.getPollResponses),
            variables: {
                pollId: pollId,
                responseId: responseId,
            },
            fetchPolicy: "network-only",
        })
            .then(function (responseResults) {
            return responseResults.data.getPollResponses.map(function (response) {
                return {
                    userId: response.pk,
                    responseId: response.GSI2SK || response.sk,
                    pollId: response.GSI2PK,
                    response: response.response,
                };
            });
        });
    };
    PollDataService.prototype.getStudentResponses = function (esId, responseId) {
        if (responseId === void 0) { responseId = null; }
        return this.client
            .query({
            query: gql(queries.getStudentResponses),
            variables: {
                esId: esId,
                responseId: responseId,
            },
            fetchPolicy: "network-only",
        })
            .then(function (responseResults) {
            return responseResults.data.getStudentResponses.map(function (response) {
                return {
                    userId: response.pk,
                    responseId: response.GSI2SK || response.sk,
                    pollId: response.GSI2PK,
                    response: response.response,
                };
            });
        });
    };
    PollDataService.prototype.getResponseUpdates = function (pollId) {
        return this.client
            .subscribe({
            query: gql(subscriptions.onAddResponseToPoll),
            variables: {
                GSI2PK: pollId,
            },
            fetchPolicy: "network-only",
        })
            .map(function (responseResult) {
            var response = responseResult.data.onAddResponseToPoll;
            return {
                userId: response.pk,
                responseId: response.GSI2SK || response.sk,
                pollId: response.GSI2PK,
                response: response.response,
            };
        });
    };
    PollDataService.prototype.getResponseDeleteUpdates = function (esId, responseId) {
        return this.client
            .subscribe({
            query: gql(subscriptions.onDeletePollResponse),
            variables: {
                pk: esId,
                sk: responseId,
            },
            fetchPolicy: "network-only",
        })
            .map(function (responseResults) {
            var response = responseResults.data.onDeletePollResponse;
            return {
                userId: response.pk,
                responseId: response.GSI2SK || response.sk,
                pollId: response.GSI2PK,
                response: response.response,
            };
        });
    };
    PollDataService.prototype.deletePollResponses = function (pollId, responseId) {
        if (responseId === void 0) { responseId = null; }
        return this.http
            .post(this.gatewayApiUrl + "/examnow-appsync-mutations/" + pollId, {
            action: "deleteResponses",
            payload: { pollId: pollId, responseId: responseId },
        })
            .toPromise();
    };
    PollDataService.prototype.addResponseToPoll = function (studentId, questionId, pollId, response) {
        var responseId = "response#" + pollId + "#" + this.padQuestionNumber(questionId);
        var data = {
            pk: studentId,
            sk: responseId,
            GSI2PK: pollId,
            GSI2SK: responseId,
            response: tslib_1.__assign({}, response),
        };
        return this.client
            .mutate({
            mutation: gql(mutations.addResponseToPoll),
            variables: data,
            optimisticResponse: function () {
                return {
                    addResponseToPoll: {
                        __typename: "Response",
                        pk: studentId,
                        sk: responseId,
                        GSI2PK: pollId,
                        GSI2SK: responseId,
                        response: tslib_1.__assign({ __typename: "ResponseDetails", choiceIndexes: [], text: null, shortAnswerBlanks: {
                                __typename: "ShortAnswerBlank",
                                blankUID: null,
                                userAnswer: null,
                            } }, cloneDeep(response)),
                    },
                };
            },
            update: function (cache, _a) {
                var addResponseToPoll = _a.data.addResponseToPoll;
                var query = gql(queries.getStudentResponses);
                var data = cache.readQuery({
                    query: query,
                    variables: { esId: studentId, responseId: responseId },
                });
                data.getStudentResponses = [addResponseToPoll];
                cache.writeQuery({ query: query, data: data });
            },
        })
            .then(function (responseResults) {
            var response = responseResults.data.addResponseToPoll;
            return {
                userId: response.pk,
                responseId: response.GSI2SK || response.sk,
                pollId: response.GSI2PK,
                response: response.response,
            };
        });
    };
    PollDataService.prototype.padQuestionNumber = function (currentQuestion) {
        var currentQuestionString = currentQuestion.toString();
        while (currentQuestionString.length < 3) {
            currentQuestionString = "0" + currentQuestionString;
        }
        return currentQuestionString;
    };
    PollDataService.prototype.getHttpOptions = function () {
        // TODO: Add test for cognito login?
        return {
            headers: new HttpHeaders({
                Authorization: this.authService.getJwt(),
                "Content-Type": "application/json",
            }),
        };
    };
    return PollDataService;
}());
export { PollDataService };
